import script from "./edit-invoices.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-invoices.vue?vue&type=script&setup=true&lang=js"

import "./edit-invoices.vue?vue&type=style&index=0&id=70697c4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70697c4e"]])

export default __exports__